module.exports = __webpack_public_path__ + "media/magnifyingGlassUsers.74dfc648.svg";